import ExampleForm from './ExampleForm';
import { connect } from 'react-redux';

export function mapStateToProps () {
  return {
    initialValues: {
      username: 'test@peerspace.com'
    }
  };
}

const ExampleFormC = connect(mapStateToProps)(ExampleForm);

export default ExampleFormC;
